import { Grid, Box, Typography } from '@mui/material';
import { Helmet } from 'react-helmet-async';
import StandardPageHeader from 'components/StandardPageHeader';
import ForceUpdateCard from './ForceUpdateCard';
import FetchDataToIntegrationServerFromAgentCard from './FetchDataToIntegrationServerFromAgentCard';
import FetchDataToIntegrationServerFromBackendCard from './FetchDataToIntegrationServerFromBackendCard';
import { EntityMappingStatusCard } from './EntityMappingStatusCard';
import { DumpFileRequestCard } from './DumpFileRequestCard';
import { PageContainer } from 'components/styled';

const DeveloperTools = () => {
  // Note: Tenant/Realm dropdowns flow removed - not needed for this page
  // Forms have their own tenant/realm selectors

  return (
    <PageContainer>
      <Grid
        container
        spacing={3}
        sx={{
          alignItems: 'stretch',
        }}
      >
        <Helmet title="Data Management" />

        <Grid size={12}>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'flex-start',
              mb: 2,
            }}
          >
            <StandardPageHeader
              title="Data Management"
              subtitle="Tools for data operations and troubleshooting"
              icon="Reports"
              sx={{ mb: 0 }}
            />
          </Box>
        </Grid>

        <Grid size={12}>
          <Typography variant="h6" component="h3" sx={{ fontWeight: 600, mb: 1 }}>
            Data Operations
          </Typography>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
          <FetchDataToIntegrationServerFromAgentCard />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
          <FetchDataToIntegrationServerFromBackendCard />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
          <ForceUpdateCard />
        </Grid>

        <Grid size={12}>
          <Typography variant="h6" component="h3" sx={{ fontWeight: 600, mt: 2 }}>
            Troubleshooting
          </Typography>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
          <EntityMappingStatusCard />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
          <DumpFileRequestCard />
        </Grid>
      </Grid>
    </PageContainer>
  );
};

export default DeveloperTools;
